export enum ActionEnum {
    ADD = 'ADD',
    ALTER = 'ALTER',
  }
